import { useReactiveVar } from '@apollo/client'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { selectedVersionsVar } from '../../apollo/reactive-vars'
import { mapVersionToCalculatedVersion } from '../../calculators/use-calculator'
import { isNotNull } from '../../util/array-utility'
import { EnergyCalculationMissing } from '../common/EnergyCalculationMissing'
import { Section } from '../common/Section'
import { DetailedEerResultsTable } from './DetailedEerResultsTable'
import { EerResultsTable } from './EerResultsTable'

export function EerPage(): React.ReactElement {
  const { t } = useTranslation()
  const selectedVersions = useReactiveVar(selectedVersionsVar)

  const calculatedVersions = selectedVersions.map((version) =>
    mapVersionToCalculatedVersion(version, version.energyCalculator),
  )
  if (calculatedVersions.some((version) => version === null)) {
    return <EnergyCalculationMissing />
  }
  const versions = calculatedVersions.filter(isNotNull)

  return (
    <>
      <Section
        title={t('eer.detailedResults')}
        subtitle={t('eer.detailedResultsDescription')}
      >
        <DetailedEerResultsTable eerVersions={versions} />
      </Section>
      <Section title={t('eer.results')}>
        <EerResultsTable versions={versions} />
      </Section>
    </>
  )
}
